import React, { Component } from 'react';
import { userActions } from 'redux/_actions';
import { connect } from 'react-redux';
import dayjs from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import { LandingNav } from 'components/nav/LandingNav';
import { DeliveryDetails } from 'components/detail/DeliveryDetails';
import QRCode from "react-qr-code";
import { t } from "i18next";
import { 
    MdDashboard,
    MdLogout,
    MdStorefront,
 } from 'react-icons/md';
import { 
    TbTruckDelivery,
    TbPackage,
 } from 'react-icons/tb';
 import { Input, Button, Row, Col, Spinner } from 'reactstrap';
 import { LoadScript, Autocomplete } from '@react-google-maps/api';
 import { generateId, invokeHttpsApi, listenDb, listenDbQuery } from 'utils/API';
 import { AuthForm } from 'components/auth/AuthForm';
import { getMonthEnd, getMonthStart, toSimpleDateTimeString } from 'utils/Utils';

class AdminPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            id: '',
            activeTab: 'delivery',
            stores: {},
            items: {},
            deliveryPayments: {},
            deliveries: {},
        };
        this.autocomplete = null
        this.onLoadMap = this.onLoadMap.bind(this);
        this.onPlaceChanged = this.onPlaceChanged.bind(this);
    }

    componentDidMount() {
        listenDb("store", ((data)=> {
            const stores = {};
            if (data) {
                for (const [k, v] of Object.entries(data)) {
                    stores[k] = v;
                }
            }

            this.setState({stores: stores});
        }))
        listenDb("items", ((data)=> {
            const items = {};
            if (data) {
                for (const [k, v] of Object.entries(data)) {
                    items[k] = v;
                }
            }

            this.setState({items: items});
        }))
        listenDbQuery("delivery", "paid", true, ((data)=> {
            const deliveries = {};
            if (data) {
                for (const [k, v] of Object.entries(data)) {
                    deliveries[k] = v;
                }
            }

            this.setState({deliveries: deliveries});
        }))
        listenDb("deliveryPayments", ((data)=> {
            const deliveryPayments = {};
            if (data) {
                for (const [k, v] of Object.entries(data)) {
                    deliveryPayments[k] = v;
                }
            }

            this.setState({deliveryPayments: deliveryPayments});
        }))
    }

    onLoadMap (autocomplete) {
        this.autocomplete = autocomplete
    }

    onPlaceChanged() {
        const {storeChoice} = this.state;

        if (this.autocomplete !== null) {
            const place = this.autocomplete.getPlace();

            const map = {};
            if (storeChoice && storeChoice.id) {
                map.id = storeChoice.id;
            }
            for (const [k,v] of Object.entries(storeChoice)) {
                map[k] = v;
            }
            this.setState({storeChoice: map, place: place});
        }
    }

    submitItem() {
        const {itemChoice} = this.state;
        
        if (!itemChoice) {
            return;
        }
        if (!itemChoice.id) {
            itemChoice.id = generateId("item");
        }
        this.setState({progress: true});
        invokeHttpsApi("delivery-submitDeliveryItem", 
        {
            map: itemChoice
        }, 
        ((data)=> {
            alert(t('change_success'));
            this.setState({progress: false});
        }), ((error)=> {
            alert(t('change_failure') + error);
            this.setState({progress: false});
        }))
    }

    renderItems() {
        const { items, progress, itemChoice } = this.state;

        let max = 0;
        for (const item of Object.values(items)) {
            if (item.index && item.index > max) {
                max = item.index;
            }
        }

        if (itemChoice) {
            if (!itemChoice.index) {
                itemChoice.index = max + 1;
            }

            return (
                <div className='book-container'>
                    <div className='input-item'>
                        <h4 className='input-label'>{t('enter_item')}</h4>
                        <Row style={{margin: 0}}>
                            <Col style={{paddingLeft: 5, paddingRight: 0}} lg={2} sm={3} xs={3}>
                                <h4 style={{position: 'absolute', width: 20, textAlign: 'center', margin: '6px 4px', fontSize: 10}}>{t('index')}</h4>
                                <Input type="number" className='form-control' name="count" id="count" style={{paddingLeft: 30, textAlign: 'right'}} onChange={e => {
                                    
                                }} value={itemChoice.index} />
                            </Col>
                            <Col style={{paddingLeft: 0, paddingRight: 5}} lg={8} sm={6} xs={6}>
                                <Input type="text" className='form-control' name="item_title" id="item_title" onChange={e => {
                                    itemChoice.title = e.target.value;
                                    this.setState({createItem: itemChoice});
                                }} value={itemChoice.title} />
                            </Col>
                            <Col style={{paddingLeft: 5, paddingRight: 0}} lg={2} sm={3} xs={3}>
                                <h4 style={{position: 'absolute', width: 20, textAlign: 'center', margin: '6px 4px', fontSize: 10}}>{t('item_helper_count')}</h4>
                                <Input type="number" className='form-control' name="count" id="count" style={{paddingLeft: 30, textAlign: 'right'}} onChange={e => {
                                    itemChoice.helperCount = parseInt(e.target.value);
                                    this.setState({itemChoice: itemChoice});
                                }} value={itemChoice.helperCount} />
                            </Col>
                        </Row>
                    </div>
                    <div className='wrap-content-parent'>
                        <div className='wrap-content-fill-child' />
                        {progress ? (
                        <Spinner size="nm" color="primary" />
                        ) : (
                        <div className='wrap-content-wrap-child'>
                            <Button className='btn-submit' onClick={e=> {
                                this.submitItem();
                            }}>{t(itemChoice.id ? 'save' : 'create_item')}</Button>
                            <Button className='btn-cancel' onClick={e=> {
                                this.setState({itemChoice: null})
                            }}>{t('close')}</Button>
                        </div>
                        )}
                    </div>
                </div>
            )
        }
        
        const itemArr = [];
        
        for (const item of Object.values(items)) {
            itemArr.push(
                <Row style={{margin: 0}}>
                    <Col sm={2} xs={3} className="vertical-center" style={{padding: 5}}>
                        <div className='wrap-content-parent'>
                            <h4 className='info-label'>
                            {item.index}
                            </h4>
                        </div>
                    </Col>
                    <Col sm={7} xs={6} className="vertical-center" style={{padding: 5}}>
                        <h4 className='info-label'>
                        {item.title}
                        </h4>
                    </Col>
                    <Col sm={3} xs={3} className="vertical-center" style={{padding: 5}}>
                        <div className='wrap-content-parent'>
                            <h4 className='info-label'>
                            {item.helperCount} {t('helpers')}
                            </h4>
                            <div className="wrap-content-fill-child" style={{marginRight: 5}} />
                            <Button className="btn-cancel" style={{margin: '5px 0px'}} onClick={e=> {
                                this.setState({itemChoice: item})
                            }}>{t('edit')}</Button>
                        </div>
                    </Col>
                </Row>
            );
            itemArr.push(<div className='divider' />);
        }
        
        return (
            <div className='info-tile'>
                <Row style={{margin: 0}}>
                    <Col sm={3} className="vertical-center" style={{padding: 5}}>
                        <h4 className='info-label'>
                        {t('items')}
                        </h4>
                    </Col>
                    <Col sm={9} className="vertical-center" style={{padding: 5}}>
                        <div className='wrap-content-parent'>
                            <div className="wrap-content-fill-child" style={{marginRight: 5}} />
                            <Button className="btn-cancel" style={{margin: '5px 0px'}} onClick={e=> {
                                this.setState({itemChoice: {
                                    helperCount: 2
                                }})
                            }}>{t('create')}</Button>
                        </div>
                    </Col>
                </Row>
                <div className='divider' />
                <div className='divider' />
                {itemArr.length > 0 ? itemArr : (
                    <div style={{height: 70, paddingTop: 25, fontSize: 14, textAlign: 'center'}}>
                    No Data
                    </div>
                )}
            </div>
        )
    }

    renderDelivery(completed) {
        const {deliveries, deliveryPayments, deliveryChoice, deleteProgress, filterStart, filterEnd} = this.state;
        const now = new Date().valueOf();
        const start = dayjs(new Date(filterStart ? filterStart : getMonthStart(now)));
        const end = dayjs(new Date(filterEnd ? filterEnd : getMonthEnd(start)));

        if (deliveryChoice) {
            return (
                <DeliveryDetails 
                    delivery={deliveryChoice}
                    deliveryPayments={deliveryPayments}
                    onCloseClick={(update)=> {
                        this.setState({deliveryChoice: null});
                    }} />
            )
        }
        let items = [];
        for (const item of Object.values(deliveries)) {
            if ((completed && item.completed === completed) || (!completed && !item.completed)) {
                if (item.deadline >= start && item.deadline <= end) {
                    items.push(item);
                }
            }
        }
        items.sort((a,b) => {
            return b.deadline - a.deadline;
        })
        
        const itemArr = [];
        
        for (const item of items) {
            if ((completed && item.completed === completed) || (!completed && !item.completed)) {
                itemArr.push(
                    <Row style={{margin: 0}}>
                        <Col sm={2} className="vertical-center" style={{padding: 5}}>
                            <h4 className='info-label'>
                            {item.customer.firstName} {item.customer.lastname}
                            </h4>
                        </Col>
                        <Col sm={2} className="vertical-center" style={{padding: 5}}>
                            <div className='info-label'>
                            {item.customer.email}
                            </div>
                        </Col>
                        <Col sm={2} className="vertical-center" style={{padding: 5}}>
                            <div className='info-label'>
                            {item.customer.phone}
                            </div>
                        </Col>
                        <Col sm={3} className="vertical-center" style={{padding: 5}}>
                            <div className='info-label'>
                            {item.location.store.formatted_address}
                            <br/>
                            {item.location.dropoff.formatted_address}
                            </div>
                        </Col>
                        <Col sm={3} className="vertical-center" style={{padding: 5}}>
                            <div className='wrap-content-parent'>
                                <div className='info-label'>
                                {toSimpleDateTimeString(item.deadline)}
                                {item.deadlineTo && <br/>}
                                {item.deadlineTo && toSimpleDateTimeString(item.deadlineTo)}
                                </div>
                                <div className="wrap-content-fill-child" style={{marginRight: 5}} />
                                {!item.completed && deleteProgress === item.id && (<Spinner size="nm" color="primary" />)}
                                {!item.completed && deleteProgress !== item.id && (
                                <Button className="btn-cancel" style={{margin: '5px 0px'}} onClick={e=> {
                                    if (window.confirm("Are you sure you want to delete this order?")) {
                                        this.setState({deleteProgress: item.id});
                                        invokeHttpsApi("delivery-deleteDelivery", {deliveryId: item.id}, () => {
                                            this.setState({deleteProgress: null});
                                        }, (error)=> {
                                            this.setState({deleteProgress: null});
                                        });
                                    }
                                }}>{t('delete')}</Button>
                                )}
                                <div className='wrap-content-parent' style={{width: 130}}>
                                <h4 className='info-label' style={{marginLeft: 5, marginRight: 5}}>
                                $<span style={{color: '#fa616a'}}>{item.price}</span> 
                                </h4>
                                <div className="wrap-content-fill-child" style={{marginRight: 5}} />
                                <Button className="btn-cancel" style={{margin: '5px 0px'}} onClick={e=> {
                                    this.setState({deliveryChoice: item})
                                }}>{t('details')}</Button>
                                </div>
                            </div>
                        </Col>
                    </Row>
                );
                itemArr.push(<div className='divider' />);
            }
        }
        
        return (
            <div>
                <div className='admin-date-picker'>
                    <div className='admin-date-label'>{t('delivery_date_filter')}</div>
                    <div className='admin-date-label'>{t('start')}:</div>
                    <div className='book-date-control'>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <MobileDatePicker
                                value={start}
                                orientation="portrait" 
                                onChange={ date => {
                                    this.setState({filterStart: date.valueOf()})
                                }} />
                        </LocalizationProvider>
                    </div>
                    <div className='admin-date-label'>{t('end')}:</div>
                    <div className='book-date-control'>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <MobileDatePicker
                                value={end}
                                orientation="portrait" 
                                onChange={ date => {
                                    this.setState({filterEnd: date.valueOf()})
                                }} />
                        </LocalizationProvider>
                    </div>
                </div>
                <div className='info-tile'>
                    <Row style={{margin: 0, height: 40}}>
                        <Col sm={2} className="vertical-center" style={{padding: 5}}>
                            <h4 className='info-label'>
                            {t('customer')}
                            </h4>
                        </Col>
                        <Col sm={2} className="vertical-center" style={{padding: 5}}>
                            <h4 className='info-label'>
                            {t('email')}
                            </h4>
                        </Col>
                        <Col sm={2} className="vertical-center" style={{padding: 5}}>
                            <h4 className='info-label'>
                            {t('phone')}
                            </h4>
                        </Col>
                        <Col sm={3} className="vertical-center" style={{padding: 5}}>
                            <h4 className='info-label'>
                            {t('store_address')}/{t('drop_off_address')}
                            </h4>
                        </Col>
                        <Col sm={3} className="vertical-center" style={{padding: 5}}>
                            <div className='wrap-content-parent'>
                                <h4 className='info-label'>
                                {t('book_date_label')}
                                </h4>
                                <div className="wrap-content-fill-child" style={{marginRight: 5}} />
                                <h4 className='info-label' style={{width: 130}}>
                                {t('price')}
                                </h4>
                            </div>
                        </Col>
                    </Row>
                    <div className='divider' />
                    <div className='divider' />
                    {itemArr.length > 0 ? itemArr : (
                        <div style={{height: 70, paddingTop: 25, fontSize: 14, textAlign: 'center'}}>
                        No Data
                        </div>
                    )}
                </div>
            </div>
        )
    }

    renderStore() {
        const {stores, storeChoice, progress, place} = this.state;

        if (storeChoice) {
            const storeLocation = storeChoice.formatted_address ? storeChoice.formatted_address : "Input place name for location";
            
            return (
                <div className='info-tile' style={{padding: '30px 15px 10px'}}>
                    <h4 className='input-label'>{t('store_address')}</h4>
                    <div className='form-setting-input'>
                        <LoadScript
                            googleMapsApiKey={process.env.REACT_APP_GOOGLE_API_KEY}
                            libraries={["places"]} >
                            <Autocomplete
                                onLoad={this.onLoadMap}
                                onPlaceChanged={this.onPlaceChanged} >
                                <input
                                    type="text"
                                    placeholder={storeLocation}
                                    className="form-control" />
                            </Autocomplete>
                        </LoadScript>
                        
                        <div className='book-info-layout'>
                            <div style={{height: 15}} />
                            <h4 className='input-label'>{t('store_name')}</h4>
                            <Input type="text" className='form-control' name="email" id="email" onChange={e => {
                                storeChoice.name = e.target.value;
                                this.setState({storeChoice: storeChoice});
                            }} value={storeChoice.name} />
                        </div>
                        
                        <div className='book-info-layout'>
                            <h4 className='input-label'>{t('store_number')}</h4>
                            <Input type="text" className='form-control' name="email" id="email" onChange={e => {
                                storeChoice.storeNumber = e.target.value;
                                this.setState({storeChoice: storeChoice});
                            }} value={storeChoice.storeNumber} />
                        </div>
                        <div style={{height: 20}} />
                        {storeChoice.id && (
                        <div className='text-center'>
                            <QRCode
                                size={256}
                                style={{ height: "auto", maxWidth: 256, width: 256 }}
                                value={"https://invoicedelivery-c1ce8.firebaseapp.com/book/" + storeChoice.id}
                                viewBox={`0 0 256 256`} />
                        </div>
                        )}
                        <div style={{height: 20}} />
                        {progress ? (
                        <div className='text-center'>
                            <Spinner size="nm" color="primary" />
                        </div>
                        ) : (
                        <div className='text-center'>
                            <Button className="btn-submit" onClick={e=> {
                                if (!storeChoice.id) {
                                    storeChoice.id = generateId("store");
                                }
                                
                                const map = {};
                                for (const [k,v] of Object.entries(storeChoice)) {
                                    map[k] = v;
                                }
                                if (place) {
                                    map.lat = place.geometry.location.lat();
                                    map.lng = place.geometry.location.lng();
                                }
                                
                                this.setState({progress: true});
                                invokeHttpsApi("delivery-submitStore", 
                                {
                                    map: map
                                }, 
                                ((data)=> {
                                    alert(t('change_success'));
                                    this.setState({progress: false, storeChoice: null});
                                }), ((error)=> {
                                    alert(t('change_failure') + error);
                                    this.setState({progress: false});
                                }))
                            }}>{t('save')}</Button>
                            <Button className="btn-cancel" style={{marginLeft: 10}} onClick={e=> {
                                this.setState({storeChoice: null});
                            }}>{t('close')}</Button>
                        </div>
                        )}
                        <div style={{height: 20}} />
                    </div>
                </div>
            )
        }
        const itemArr = [];
        
        for (const item of Object.values(stores)) {
            itemArr.push(
                <Row style={{margin: 0}}>
                    <Col sm={3} className="vertical-center" style={{padding: 5}}>
                        <h4 className='info-label'>
                        <span style={{color: '#A6DC34'}}>{item.storeNumber}</span> {item.name}
                        </h4>
                    </Col>
                    <Col sm={9} className="vertical-center" style={{padding: 5}}>
                        <div className='wrap-content-parent'>
                            <h4 className='info-label'>
                            {item.formatted_address}
                            </h4>
                            <div className="wrap-content-fill-child" style={{marginRight: 5}} />
                            <Button className="btn-cancel" style={{margin: '5px 0px'}} onClick={e=> {
                                this.setState({storeChoice: item})
                            }}>{t('edit')}</Button>
                        </div>
                    </Col>
                </Row>
            );
            itemArr.push(<div className='divider' />);
        }
        
        return (
            <div className='info-tile'>
                <Row style={{margin: 0}}>
                    <Col sm={3} className="vertical-center" style={{padding: 5}}>
                        <h4 className='info-label'>
                        {t('name')}
                        </h4>
                    </Col>
                    <Col sm={9} className="vertical-center" style={{padding: 5}}>
                        <div className='wrap-content-parent'>
                            <h4 className='info-label'>
                            {t('address')}
                            </h4>
                            <div className="wrap-content-fill-child" style={{marginRight: 5}} />
                            <Button className="btn-cancel" style={{margin: '5px 0px'}} onClick={e=> {
                                this.setState({storeChoice: {}})
                            }}>{t('create')}</Button>
                        </div>
                    </Col>
                </Row>
                <div className='divider' />
                <div className='divider' />
                {itemArr.length > 0 ? itemArr : (
                    <div style={{height: 70, paddingTop: 25, fontSize: 14, textAlign: 'center'}}>
                    No Data
                    </div>
                )}
            </div>
        )
    }

    renderContents() {
        const {activeTab} = this.state;
        
        return (
            <div className='admin-page'>
                <div className='admin-side-menu'>
                    <div className='admin-side-title'>
                        <h4 className='admin-side-title-icon'>
                            <MdDashboard />
                        </h4>
                        <h4 className='admin-side-menu-title'>
                            {t('dashboard')}
                        </h4>
                    </div>
                    <div className={'admin-side-item' + (activeTab === 'delivery' ? ' selected' : '')} onClick={e=> {
                        this.setState({activeTab: 'delivery', deliveryChoice: null});
                    }}>
                        <h4 className='admin-side-menu-icon'>
                            <TbTruckDelivery />
                        </h4>
                        <div className='admin-side-menu-text'>
                            {t('deliveries')}
                        </div>
                    </div>
                    <div className={'admin-side-item' + (activeTab === 'completed' ? ' selected' : '')} onClick={e=> {
                        this.setState({activeTab: 'completed', deliveryChoice: null});
                    }}>
                        <h4 className='admin-side-menu-icon'>
                            <TbTruckDelivery />
                        </h4>
                        <div className='admin-side-menu-text'>
                            {t('deliveries_completed')}
                        </div>
                    </div>
                    <div className={'admin-side-item' + (activeTab === 'store' ? ' selected' : '')} onClick={e=> {
                        this.setState({activeTab: 'store'});
                    }}>
                        <h4 className='admin-side-menu-icon'>
                            <MdStorefront />
                        </h4>
                        <div className='admin-side-menu-text'>
                            {t('stores')}
                        </div>
                    </div>
                    <div className={'admin-side-item' + (activeTab === 'items' ? ' selected' : '')} onClick={e=> {
                        this.setState({activeTab: 'items'});
                    }}>
                        <h4 className='admin-side-menu-icon'>
                            <TbPackage />
                        </h4>
                        <div className='admin-side-menu-text'>
                            {t('items')}
                        </div>
                    </div>
                    <div className={'admin-side-item' + (activeTab === 'items' ? ' selected' : '')} onClick={e=> {
                        this.props.logout();
                    }}>
                        <h4 className='admin-side-menu-icon'>
                            <MdLogout />
                        </h4>
                        <div className='admin-side-menu-text'>
                            {t('logout')}
                        </div>
                    </div>
                </div>
                <div className='admin-contents'>
                    <div>
                    {activeTab === 'delivery' && this.renderDelivery(false)}
                    {activeTab === 'completed' && this.renderDelivery(true)}
                    {activeTab === 'store' && this.renderStore()}
                    {activeTab === 'items' && this.renderItems()}
                    </div>
                </div>
            </div>
        );
    }

    renderAuthForm() {
        return (
            <AuthForm onClickClose={()=>{
                this.setState({showAuth: false})
            }} />
        );
    }

    render() {
        const {user} = this.props;
        const {landingData} = this.state;

        return (
            <div>
                <LandingNav landingData={landingData} />
                {user && user.isAdmin ? this.renderContents() : this.renderAuthForm()}
            </div>
        );
    }
}

function mapState(state) {
    const { isAdmin, loggingIn, user, redirectTo } = state.authentication;
    return { isAdmin, loggingIn, user, redirectTo };
}

const actionCreators = {
    login: userActions.login,
    logout: userActions.logout,
    setAuthRedirect: userActions.setAuthRedirect,
};

const connectedBookPage = connect(mapState, actionCreators)(AdminPage);
export { connectedBookPage as AdminPage };
